<div class="section">
    <div class="container">
        
    <h5 [innerHTML]="item.title" class="center pink-text" *ngFor="let item of intro"> </h5>
    
   <div *ngFor="let item of intro">
        <p *ngFor="let item2 of item.intro"  [innerHTML]="item2.para"> 
        </p>
        
   </div>
     
    </div>
</div>